import { LineReveal, FadeUp, Counter } from "@/components/site/Reveal";

const TERMS = [
  { value: 6000, prefix: "$", unit: "per month", note: "wiped off your power costs", id: "monthly" },
  { op: "×12" },
  { value: 72000, prefix: "$", unit: "per year", note: "back in your pocket", id: "yearly" },
  { op: "×25" },
  { value: 1.8, prefix: "$", suffix: "M+", decimals: 1, unit: "over 25 years", note: "in your family's bank account", id: "lifetime" },
];

export const Equation = () => (
  <section data-testid="equation-section" className="relative bg-[var(--concrete)] text-[var(--ink)] overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 lg:px-10 py-24 lg:py-36">
      <div className="grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-7">
          <p className="eyebrow eyebrow-dark">The 100kW equation</p>
          <LineReveal onView lines={["Stop tearing up", "your power bill."]} className="mt-5 font-display font-black uppercase leading-[0.88] text-5xl sm:text-6xl lg:text-7xl" />
        </div>
        <FadeUp className="lg:col-span-5">
          <p className="text-base sm:text-lg text-slate-700 leading-relaxed">
            Any normal carwash is eligible for up to 100 kilowatts of solar on its roof — without special engineering or any energy redesigns. That size permanently wipes out around $6,000 of power costs every month.
          </p>
        </FadeUp>
      </div>
      <div className="mt-16 lg:mt-24 grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr_auto_1fr] items-center gap-6 lg:gap-4">
        {TERMS.map((t, i) =>
          t.op ? (
            <FadeUp key={t.op} delay={i * 0.08} className="justify-self-center">
              <span className="grid place-items-center h-16 w-16 lg:h-20 lg:w-20 rounded-full bg-[var(--sun)] font-display font-black text-2xl lg:text-3xl">{t.op}</span>
            </FadeUp>
          ) : (
            <FadeUp key={t.id} delay={i * 0.08} className={`rounded-2xl p-7 lg:p-9 ${t.id === "lifetime" ? "bg-[var(--ink)] text-white" : "bg-white"} border border-black/5`}>
              <p className={`font-mono text-xs tracking-[0.2em] uppercase ${t.id === "lifetime" ? "text-[var(--sun)]" : "text-[#0057c2]"}`}>{t.unit}</p>
              <p className="mt-3 font-display font-black text-6xl lg:text-7xl xl:text-8xl leading-none">
                <Counter testId={`equation-${t.id}`} value={t.value} prefix={t.prefix} suffix={t.suffix} decimals={t.decimals} />
              </p>
              <p className={`mt-3 ${t.id === "lifetime" ? "text-slate-300" : "text-slate-600"}`}>{t.note}</p>
            </FadeUp>
          )
        )}
      </div>
      <p className="mt-10 text-sm text-slate-600 max-w-2xl">Instead of handing it to AGL, Origin, Ergon and the rest of the power companies. Figures based on a large carwash 100kW system.</p>
    </div>
  </section>
);
